module.exports = __webpack_public_path__ + "img/banner2.2faede2e.png";